// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3mwLE","boxTitle":"Qualiphy_boxTitle__3lomb","box":"Qualiphy_box__21ZQZ","toggleWrap":"Qualiphy_toggleWrap__2Ukzx"};